import React from 'react'
import AdaptableProjectNote from './AdaptableProjectNote'
import './AppelsShowcase.css'

const APP_URL = 'https://appel.taskpro.fr'

const AppelsShowcase = ({ onApplicationRequest }) => (
    <article className="appels-showcase">
        <a
            className="appels-window"
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ouvrir Appels AM Services"
        >
            <div className="appels-window-bar">
                <i></i><i></i><i></i><span>appel.taskpro.fr</span>
            </div>

            <div className="appels-window-body">
                <div className="appels-demo-head">
                    <div>
                        <small>Appels & interventions</small>
                        <strong>Suivi des dépannages</strong>
                    </div>
                    <b>+ Ajouter un appel</b>
                </div>

                <div className="appels-demo-stats">
                    <span><small>Urgents</small><strong>1</strong></span>
                    <span><small>À traiter</small><strong>2</strong></span>
                    <span><small>En cours</small><strong>1</strong></span>
                </div>

                <div className="appels-demo-table">
                    <div className="appels-demo-row heading">
                        <span>Client</span><span>Urgence</span><span>Statut</span><span>Affecté à</span><span>Suivi</span>
                    </div>
                    <div className="appels-demo-row urgent">
                        <span><strong>Boulangerie Martin</strong><small>Chambre froide en défaut</small></span>
                        <span className="appels-pill red">Urgent</span>
                        <span className="appels-pill blue">À traiter</span>
                        <span>—</span><span>—</span>
                    </div>
                    <div className="appels-demo-row">
                        <span><strong>Résidence Les Acacias</strong><small>Contrôle de la ventilation</small></span>
                        <span className="appels-pill neutral">Normal</span>
                        <span className="appels-pill blue">En cours</span>
                        <span className="appels-person purple">Gaëtan</span>
                        <span className="appels-person pink">Eddy</span>
                    </div>
                </div>
            </div>

            <em>Explorer Appels AM Services ↗</em>
        </a>

        <div className="appels-showcase-copy">
            <span className="appels-signature">Une réalisation AM Services</span>
            <h3>Appels AM Services</h3>
            <h4>De la demande client à l’intervention terminée, aucun appel ne se perd.</h4>
            <p>
                Cette application métier centralise les appels de dépannage et les demandes du bureau.
                Les équipes identifient les urgences, affectent les techniciens et suivent chaque prise en
                charge jusqu’à sa résolution et son archivage.
            </p>
            <ul>
                <li>Centralisation des appels</li>
                <li>Gestion des urgences</li>
                <li>Affectation des techniciens</li>
                <li>Suivi et archivage</li>
            </ul>
            <AdaptableProjectNote />
            <div className="appels-showcase-actions">
                <a className="appels-primary" href={APP_URL} target="_blank" rel="noopener noreferrer">
                    Tester la démo <span aria-hidden="true">↗</span>
                </a>
                <button type="button" className="appels-secondary" onClick={onApplicationRequest}>
                    Créer mon application métier
                </button>
            </div>
        </div>
    </article>
)

export default AppelsShowcase
